import { ProjectEstimate } from './../models/project-estimate.model';
import { AssetLocation } from './../models/asset-location.model';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { EstimateFunction } from '../models/estimate-function.model';
import { ChargeType } from '../models/charge-type.model';
import { UtilityAccount } from '../models/utility-account.model';
import { RetirementUnit } from '../models/retirement-unit.model';
import { UnitReminder } from '../models/unit-reminder.model';
import { CapitalRetirement } from '../models/capital-retirement.model';
import { WorkOrderType } from '../models/work-order-type.model';
import { MajorLocation } from '../models/major-location.model';
import { Activity } from '../models/activity.model';
import { ContractAdmin } from '../models/contract-admin.model';
import { RespCenter } from '../models/resp-center.model';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { Router } from '@angular/router';
import { OperatingUnit } from '../models/operating-unit.model';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-estimate',
  templateUrl: './estimate.component.html',
  styleUrls: ['./estimate.component.scss'],
  standalone: false,
})
export class EstimateComponent implements OnInit {
  webMethodUserName = this.config.getConfig('WebMethodUserName');
  webMethodPass = this.config.getConfig('WebMethodPassword');
  fundingProjectID: string;
  projectName: string;
  projectChargeIndicator: string;
  assetLocation: AssetLocation;
  projectEstimates: ProjectEstimate[];
  capitalRetirements: CapitalRetirement[];
  functions: EstimateFunction[];
  chargeTypes: ChargeType[];
  chargeTypesBeforeAdd: ChargeType[];
  businessUnit: string;
  assetLocationOptions: AssetLocation[];
  utilityAccountsForRemoval: UtilityAccount[];
  submittingEstimate: boolean;
  powerPlanProjectType: WorkOrderType;
  chargingProjectID: string;
  costEstimate: number;
  projectLongDescription: string;
  estimatedStartDate: Date;
  estimatedInServiceDate: Date;
  lateWaitPeriod: number;
  estimatedCompletionDate: Date;
  majorLocation: MajorLocation;
  firstStandardActivity: string;
  standardActivities: string[];
  firstActivity: Activity;
  activities: Activity[];
  projectManagerLAN: string;
  contractAdmin: ContractAdmin;
  contractAdminLAN: string;
  projectInitiatorLAN: string;
  problemStatement: string;
  proposedObjective: string;
  notes: string;
  respCenter: RespCenter;
  operatingUnit: OperatingUnit;
  xmlDoc: any;
  parser: DOMParser;
  submittingProject: boolean;

  ngOnInit() {
    this.projectEstimates = [];
    this.parser = new DOMParser();
    this.capitalRetirements = [];
    this.loadProjectData();
    this.getFunctionAndChargeType();
    this.submittingEstimate = false;
  }

  constructor(
    private config: ConfigService,
    private dataService: DataService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  loadProjectData() {
    this.fundingProjectID = sessionStorage.getItem('fundingProjectID');
    this.projectName = sessionStorage.getItem('chargingProjectName');
    this.projectChargeIndicator = sessionStorage.getItem('projectChargeIndicator');
    this.assetLocation = JSON.parse(sessionStorage.getItem('assetLocation'));
    this.businessUnit = JSON.parse(sessionStorage.getItem('businessUnit'));
    this.assetLocationOptions = JSON.parse(sessionStorage.getItem('assetLocationOptions'));
    let powerPlanProjectTypeCheck = sessionStorage.getItem('powerPlanProjectType');
    if (powerPlanProjectTypeCheck) {
      this.powerPlanProjectType = JSON.parse(powerPlanProjectTypeCheck);
    } else {
      this.powerPlanProjectType = null;
    }
    this.chargingProjectID = sessionStorage.getItem('chargingProjectID');
    let costEstimateCheck = sessionStorage.getItem('costEstimate');
    if (costEstimateCheck) {
      this.costEstimate = Number(costEstimateCheck);
    } else {
      this.costEstimate = null;
    }
    this.projectLongDescription = sessionStorage.getItem('chargingProjectLongDescription');
    let startDateCheck = sessionStorage.getItem('estimatedStartDate');
    if (startDateCheck) {
      this.estimatedStartDate = new Date(startDateCheck);
      this.estimatedStartDate.setDate(this.estimatedStartDate.getDate() + 1);
    } else {
      this.estimatedStartDate = null;
    }
    let inServiceDateCheck = sessionStorage.getItem('estimatedInServiceDate');
    if (inServiceDateCheck) {
      this.estimatedInServiceDate = new Date(inServiceDateCheck);
      this.estimatedInServiceDate.setDate(this.estimatedInServiceDate.getDate() + 1);
    } else {
      this.estimatedInServiceDate = null;
    }
    let dateCopy = new Date(this.estimatedInServiceDate.getTime());
    this.lateWaitPeriod = parseInt(sessionStorage.getItem('lateWaitPeriod'));
    let originalDate = dateCopy.getDate();
    let completeDate;
    if (this.lateWaitPeriod == 0 || !this.lateWaitPeriod) {
      completeDate = new Date(dateCopy.setMonth(dateCopy.getMonth() + 3));
    } else {
      completeDate = new Date(dateCopy.setMonth(dateCopy.getMonth() + this.lateWaitPeriod));
    }
    let dateOffset = 24 * 60 * 60 * 1000;
    if ((originalDate === 31 || originalDate === 30) && completeDate.getDate() === 1) {
      while (completeDate.getDate() < 28) {
        completeDate.setTime(completeDate.getTime() - dateOffset);
      }
    }
    this.estimatedCompletionDate = completeDate;
    let majorLocationCheck = sessionStorage.getItem('majorLocation');
    if (majorLocationCheck) {
      this.majorLocation = JSON.parse(majorLocationCheck);
    } else {
      this.majorLocation = null;
    }
    let standardActivityCheck = sessionStorage.getItem('standardActivities');
    if (standardActivityCheck) {
      this.standardActivities = JSON.parse(standardActivityCheck);
      if (this.standardActivities.length > 0) {
        this.firstStandardActivity = this.standardActivities[0];
        this.standardActivities.splice(0, 1);
      }
    } else {
      this.standardActivities = [];
    }
    let activitiesCheck = sessionStorage.getItem('activities');
    if (activitiesCheck) {
      this.activities = JSON.parse(activitiesCheck);
      if (this.activities.length > 0) {
        this.firstActivity = this.activities[0];
        this.activities.splice(0, 1);
      }
    } else {
      this.activities = [];
    }
    this.projectManagerLAN = sessionStorage.getItem('projectManagerID');
    let contractAdminCheck = sessionStorage.getItem('contractAdmin');
    if (contractAdminCheck) {
      this.contractAdmin = JSON.parse(contractAdminCheck);
    } else {
      this.contractAdmin = null;
    }
    this.contractAdminLAN = this.contractAdmin.users;
    this.projectInitiatorLAN = JSON.parse(sessionStorage.getItem('fullTokenPayload')).username;
    this.problemStatement = sessionStorage.getItem('problemStatement');
    this.proposedObjective = sessionStorage.getItem('proposedObjective');
    this.notes = sessionStorage.getItem('notes');
    this.notes = this.notes.replace(/[^\x00-\x7F\xB0\u2019\u201D]/g, ' ');
    let operatingUnitCheck = sessionStorage.getItem('operatingUnit');
    if (operatingUnitCheck) {
      this.operatingUnit = JSON.parse(operatingUnitCheck);
    } else {
      this.operatingUnit = null;
    }
    let respCenterCheck = sessionStorage.getItem('respCenter');
    if (respCenterCheck) {
      this.respCenter = JSON.parse(respCenterCheck);
    } else {
      this.respCenter = null;
    }
  }

  functionDisabled() {
    return !this.functions || this.functions.length === 0;
  }

  utilityAccountDisabled(index: number) {
    return (
      !this.projectEstimates[index].utilityAccountOptions ||
      this.projectEstimates[index].utilityAccountOptions.length === 0
    );
  }

  retirementUnitDisabled(index: number) {
    return (
      !this.projectEstimates[index].retirementUnitOptions ||
      this.projectEstimates[index].retirementUnitOptions.length === 0
    );
  }

  chargeTypeDisabled(index: number) {
    return !this.projectEstimates[index].unitReminder;
  }

  utilityAccountRemovalDisabled() {
    return !this.utilityAccountsForRemoval || this.utilityAccountsForRemoval.length === 0;
  }

  capitalRetirementUnitDisabled(index: number) {
    return (
      !this.capitalRetirements[index].retirementUnitOptions ||
      this.capitalRetirements[index].retirementUnitOptions.length === 0
    );
  }

  estimateTotal() {
    let runningTotal: number = 0;
    for (var i = 0; i < this.projectEstimates.length; i++) {
      if (this.projectEstimates[i].estimatedCosts) {
        runningTotal += this.projectEstimates[i].estimatedCosts;
      }
    }
    return parseFloat(parseFloat(runningTotal.toString()).toPrecision(12));
  }

  functionChanged(index: number) {
    this.projectEstimates[index].utilityAccount = null;
    this.projectEstimates[index].utilityAccountOptions = [];
    this.projectEstimates[index].retirementUnit = null;
    this.projectEstimates[index].retirementUnitOptions = [];
    this.projectEstimates[index].unitReminder = null;
  }

  utilityAccountChanged(index: number) {
    this.projectEstimates[index].retirementUnit = null;
    this.projectEstimates[index].retirementUnitOptions = [];
    this.projectEstimates[index].unitReminder = null;
  }

  retirementUnitChanged(index: number) {
    this.projectEstimates[index].unitReminder = null;
  }

  utilityAccountForRemovalChanged(index: number) {
    this.capitalRetirements[index].retirementUnit = null;
    this.capitalRetirements[index].retirementUnitOptions = [];
  }

  chargeTypeChanged(index: number) {
    this.projectEstimates[index].quantity = null;
  }

  chargeTypeIsMaterial(index: number) {
    if (!this.projectEstimates[index].chargeType) {
      return false;
    }
    return this.projectEstimates[index].chargeType.chg_type_descr.substring(0, 8) === 'Material';
  }

  getFunctionAndChargeType() {
    let callBody = {
      prjChargeInd: this.projectChargeIndicator,
    };
    this.dataService.getAthenaData('fun_charge_type', callBody).subscribe(
      (result) => {
        this.getUtilityForRemoval();
        let startOfChargeType = this.parseForFunction(JSON.stringify(result));
        this.parseForChargeType(JSON.stringify(result).substring(startOfChargeType));
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Function and Charge Type Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Function and Charge Type Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getUtilityForRemoval() {
    let callBody = {
      businessUnit: this.businessUnit.toString(),
    };
    this.dataService.getAthenaData('cap_ret_utility_acct', callBody).subscribe(
      (result) => {
        this.parseForUtilityAccountRemoval(JSON.stringify(result));
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Utility for Removal Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Utility for Removal Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getUtilityAccount(estimateFunction: EstimateFunction, index: number) {
    let callBody = {
      businessUnit: this.businessUnit.toString(),
      fundProjId: this.fundingProjectID,
      functionId: estimateFunction.func_class_id,
    };
    this.dataService.getAthenaData('prj_est_util_acct', callBody).subscribe(
      (result) => {
        this.parseForUtilityAccount(JSON.stringify(result), index);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Utility Account Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Utility Account Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getRetirementUnit(utilityAccount: UtilityAccount, index: number) {
    const busSegmentId = sessionStorage.getItem('selectedBusSegmentId');
    let callBody = {
      businessUnit: this.businessUnit.toString(),
      fundProjId: this.fundingProjectID,
      functionId: this.projectEstimates[index].projectFunction.func_class_id,
      utilAcctId: utilityAccount.utility_account_id,
      busSegmentId: busSegmentId,
    };
    this.dataService.getAthenaData('prj_est_retirement_unit', callBody).subscribe(
      (result) => {
        this.parseForRetirementUnit(JSON.stringify(result), index);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Retirement Unit Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Retirement Unit Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getUnit(retirementUnit: RetirementUnit, index: number) {
    let callBody = {
      retUnitId: retirementUnit.retirement_unit_id,
    };
    this.dataService.getAthenaData('uom_per_ruid', callBody).subscribe(
      (result) => {
        this.parseForUnit(JSON.stringify(result), index);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat('Get Unit Error - ', error.error.message);
        } else {
          errorDescription = errorDescription.concat('Get Unit Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getRetirementUnitCapital(utilityAccount: UtilityAccount, index: number) {
    let callBody = {
      businessUnit: this.businessUnit.toString(),
      utilAcctId: utilityAccount.utility_account_id,
    };
    this.dataService.getAthenaData('cap_ret_retirement_unit_nonrre', callBody).subscribe(
      (result) => {
        this.parseForRetirementUnitCapital(JSON.stringify(result), index);
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Retirement Unit Capital Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Retirement Unit Capital Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  parseForFunction(arrayString: string) {
    let i = 2;
    this.functions = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let functionEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(functionEntry);
      this.functions.push(
        new EstimateFunction(entryParse.func_class_id.trim(), entryParse.description.trim())
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForChargeType(arrayString: string) {
    let i = 1;
    this.chargeTypesBeforeAdd = [];
    this.chargeTypes = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let chargeTypeEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(chargeTypeEntry);
      this.chargeTypesBeforeAdd.push(
        new ChargeType(
          entryParse.value.trim(),
          entryParse.charge_type.trim(),
          entryParse.est_chg_type_id.trim(),
          entryParse.chg_type_descr.trim(),
          entryParse.expenditure_type_id.trim(),
          entryParse.expenditure_type_descr.trim()
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    for (let j = 0; j < this.chargeTypesBeforeAdd.length; j++) {
      this.chargeTypes.push(
        new ChargeType(
          this.chargeTypesBeforeAdd[j].value,
          this.chargeTypesBeforeAdd[j].charge_type,
          this.chargeTypesBeforeAdd[j].est_chg_type_id,
          this.chargeTypesBeforeAdd[j].chg_type_descr + ' - Install Cost',
          this.chargeTypesBeforeAdd[j].expenditure_type_id,
          this.chargeTypesBeforeAdd[j].expenditure_type_descr
        )
      );
      this.chargeTypes.push(
        new ChargeType(
          this.chargeTypesBeforeAdd[j].value,
          this.chargeTypesBeforeAdd[j].charge_type,
          this.chargeTypesBeforeAdd[j].est_chg_type_id,
          this.chargeTypesBeforeAdd[j].chg_type_descr + ' - Removal Cost',
          this.chargeTypesBeforeAdd[j].expenditure_type_id,
          this.chargeTypesBeforeAdd[j].expenditure_type_descr
        )
      );
    }
  }

  parseForUtilityAccount(arrayString: string, index: number) {
    let i = 2;
    let utilityAccounts: UtilityAccount[] = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let utilityAccountEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(utilityAccountEntry);
      utilityAccounts.push(
        new UtilityAccount(
          entryParse.bus_segment_id.trim(),
          entryParse.utility_account_id,
          entryParse.util_account_descr.trim()
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    this.projectEstimates[index].utilityAccountOptions = utilityAccounts;
  }

  parseForUtilityAccountRemoval(arrayString: string) {
    let i = 2;
    this.utilityAccountsForRemoval = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let utilityAccountEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(utilityAccountEntry);
      this.utilityAccountsForRemoval.push(
        new UtilityAccount(
          entryParse.bus_segment_id,
          entryParse.utility_account_id,
          entryParse.util_account_descr.trim()
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    return i + 1;
  }

  parseForRetirementUnit(arrayString: string, index: number) {
    let i = 2;
    let retirementUnits: RetirementUnit[] = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let retirementUnitEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(retirementUnitEntry);
      retirementUnits.push(
        new RetirementUnit(
          entryParse.retirement_unit_id.trim(),
          entryParse.retirement_unit_descr.trim()
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    this.projectEstimates[index].retirementUnitOptions = retirementUnits;
  }

  parseForRetirementUnitCapital(arrayString: string, index: number) {
    let i = 2;
    let retirementUnits: RetirementUnit[] = [];
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let retirementUnitEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(retirementUnitEntry);
      retirementUnits.push(
        new RetirementUnit(
          entryParse.retirement_unit_id.trim(),
          entryParse.retirement_unit_descr.trim()
        )
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
    this.capitalRetirements[index].retirementUnitOptions = retirementUnits;
  }

  parseForUnit(arrayString: string, index: number) {
    let i = 2;
    while (arrayString[i] !== ']') {
      let iStart = i;
      while (arrayString[i] !== '}') {
        i++;
      }
      let unitEntry = arrayString
        .substring(iStart, i + 1)
        .replace(/\\\"/g, '"')
        .replace(/\\\\/g, '\\');
      let entryParse = JSON.parse(unitEntry);
      this.projectEstimates[index].unitReminder = new UnitReminder(
        entryParse.retirement_unit.trim(),
        entryParse.uom_reminder.trim()
      );
      while (arrayString[i] !== ']' && arrayString[i] !== '{') {
        i++;
      }
    }
  }

  addNewEstimate() {
    if (this.projectEstimates && this.projectEstimates.length - 1 != -1) {
      let projectEstimateLength = this.projectEstimates.length - 1;
      let newProjectFunction: EstimateFunction = new EstimateFunction();
      let newUtilityAccount: UtilityAccount = new UtilityAccount();
      let newRetirementUnit: RetirementUnit = new RetirementUnit();
      let newAssetLocation: AssetLocation = new AssetLocation();
      let newUtilityAccountOptions: UtilityAccount[] = [];
      let newRetirementUnitOptions: RetirementUnit[] = [];
      let newUnitReminder: UnitReminder = new UnitReminder();
      if (this.projectEstimates[projectEstimateLength].projectFunction) {
        newProjectFunction.description =
          this.projectEstimates[projectEstimateLength].projectFunction.description;
        newProjectFunction.func_class_id =
          this.projectEstimates[projectEstimateLength].projectFunction.func_class_id;
      }
      if (this.projectEstimates[projectEstimateLength].utilityAccount) {
        newUtilityAccount.bus_segment_id =
          this.projectEstimates[projectEstimateLength].utilityAccount.bus_segment_id;
        newUtilityAccount.util_account_descr =
          this.projectEstimates[projectEstimateLength].utilityAccount.util_account_descr;
        newUtilityAccount.utility_account_id =
          this.projectEstimates[projectEstimateLength].utilityAccount.utility_account_id;
      }
      if (this.projectEstimates[projectEstimateLength].retirementUnit) {
        newRetirementUnit.retirement_unit_descr =
          this.projectEstimates[projectEstimateLength].retirementUnit.retirement_unit_descr;
        newRetirementUnit.retirement_unit_id =
          this.projectEstimates[projectEstimateLength].retirementUnit.retirement_unit_id;
      }
      if (this.projectEstimates[projectEstimateLength].assetLocation) {
        newAssetLocation.ext_asset_location =
          this.projectEstimates[projectEstimateLength].assetLocation.ext_asset_location;
        newAssetLocation.long_description =
          this.projectEstimates[projectEstimateLength].assetLocation.long_description;
      }
      if (this.projectEstimates[projectEstimateLength].utilityAccountOptions) {
        newUtilityAccountOptions =
          this.projectEstimates[projectEstimateLength].utilityAccountOptions;
      }
      if (this.projectEstimates[projectEstimateLength].retirementUnitOptions) {
        newRetirementUnitOptions =
          this.projectEstimates[projectEstimateLength].retirementUnitOptions;
      }
      if (this.projectEstimates[projectEstimateLength].unitReminder) {
        newUnitReminder.retirement_unit =
          this.projectEstimates[projectEstimateLength].unitReminder.retirement_unit;
        newUnitReminder.uom_reminder =
          this.projectEstimates[projectEstimateLength].unitReminder.uom_reminder;
      }
      this.projectEstimates.push(
        new ProjectEstimate(
          newProjectFunction,
          newUtilityAccount,
          newRetirementUnit,
          null,
          null,
          newAssetLocation,
          null,
          newUtilityAccountOptions,
          newRetirementUnitOptions,
          newUnitReminder
        )
      );
    } else {
      this.projectEstimates.push(new ProjectEstimate());
    }
  }

  compareProjectFunction(o1: EstimateFunction, o2: EstimateFunction): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return o1.description == o2.description && o1.func_class_id == o2.func_class_id;
  }

  compareUtilityAccount(o1: UtilityAccount, o2: UtilityAccount): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.bus_segment_id == o2.bus_segment_id &&
      o1.util_account_descr == o2.util_account_descr &&
      o1.utility_account_id == o2.utility_account_id
    );
  }

  compareRetirementUnit(o1: RetirementUnit, o2: RetirementUnit): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.retirement_unit_descr == o2.retirement_unit_descr &&
      o1.retirement_unit_id == o2.retirement_unit_id
    );
  }

  compareAssetLocation(o1: AssetLocation, o2: AssetLocation): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return (
      o1.ext_asset_location == o2.ext_asset_location && o1.long_description == o2.long_description
    );
  }

  deleteEstimate() {
    this.projectEstimates.pop();
  }

  addCapitalRetirement() {
    this.capitalRetirements.push(new CapitalRetirement());
  }

  deleteCapitalRetirement() {
    this.capitalRetirements.pop();
  }

  saveAndSubmit() {
    this.submittingEstimate = true;
    let estimateSet = [];
    for (let i = 0; i < this.projectEstimates.length; i++) {
      let measurementType = '';
      if (this.projectEstimates[i].unitReminder) {
        measurementType = this.projectEstimates[i].unitReminder.uom_reminder;
      }
      let quantityValue = this.projectEstimates[i].quantity;
      let quantityString;
      if (quantityValue) {
        quantityString = quantityValue.toString();
      } else {
        quantityString = '0';
      }
      estimateSet.push({
        function: this.projectEstimates[i].projectFunction.description,
        quantity: quantityString,
        measurementType: measurementType,
        estimatedCosts: this.projectEstimates[i].estimatedCosts.toString(),
        chargeType: this.projectEstimates[i].chargeType.chg_type_descr,
        assetLocation: this.projectEstimates[i].assetLocation.long_description,
        retirementUnit: this.projectEstimates[i].retirementUnit.retirement_unit_descr,
        utilityAccount: this.projectEstimates[i].utilityAccount.util_account_descr,
      });
    }
    let callBody = {
      charging_project_id: sessionStorage.getItem('chargingProjectID'),
      estimates: estimateSet,
    };
    this.dataService.saveEstimatesData(callBody).subscribe(
      (result) => {
        let capitalRetirementsSet = [];
        let addressValue;
        for (let i = 0; i < this.capitalRetirements.length; i++) {
          if (this.capitalRetirements[i].address) {
            addressValue = this.capitalRetirements[i].address;
          } else {
            addressValue = '';
          }
          capitalRetirementsSet.push({
            utilityAccountBeingRemoved:
              this.capitalRetirements[i].utilityAccountBeingRemoved.util_account_descr,
            retirementUnit: this.capitalRetirements[i].retirementUnit.retirement_unit_descr,
            originalInstalledYear: this.capitalRetirements[i].originalInstalledYear.toString(),
            quantity: this.capitalRetirements[i].quantity.toString(),
            assetLocation: addressValue,
          });
        }
        let callBody = {
          charging_project_id: sessionStorage.getItem('chargingProjectID'),
          capital_retirements: capitalRetirementsSet,
        };
        this.dataService.saveCapitalRetirementsData(callBody).subscribe(
          (result) => {
            if (this.capitalRetirements.length > 0) {
              this.submitNotesField();
            } else {
              this.submitEstimate();
            }
          },
          (error) => {
            console.log('error', error);
            let errorType = '';
            let errorDescription = '';
            if (error.error.message) {
              errorDescription = errorDescription.concat(
                'Capital Retirements Save Error - ',
                error.error.message
              );
            } else {
              errorDescription = errorDescription.concat('Capital Retirements Save Error');
            }
            errorType = errorType.concat(error.status, ' ', error.statusText);
            let dataStructure = {
              errorType: errorType,
              errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
              data: dataStructure,
              disableClose: true,
            });
            this.submittingEstimate = false;
          }
        );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Estimates Save Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Estimates Save Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
        this.submittingEstimate = false;
      }
    );
  }

  submitNotesField() {
    // augmenting Notes field
    let notesAugment = this.notes.concat('\n');
    for (let i = 0; i < this.capitalRetirements.length; i++) {
      notesAugment = notesAugment.concat(
        'UA=' +
          this.capitalRetirements[i].utilityAccountBeingRemoved.util_account_descr +
          '; RU=' +
          this.capitalRetirements[i].retirementUnit.retirement_unit_descr +
          '; InstYr=' +
          this.capitalRetirements[i].originalInstalledYear +
          '; Qty=' +
          this.capitalRetirements[i].quantity +
          '; Address=' +
          this.capitalRetirements[i].address
      );
      if (i < this.capitalRetirements.length - 1) {
        notesAugment = notesAugment.concat('\n');
      }
    }
    let doc = document.implementation.createDocument('', '', null);
    const pi = doc.createProcessingInstruction('xml', 'version="1.0" encoding="UTF-8"');
    doc.insertBefore(pi, doc.firstChild);
    let elem1 = doc.createElement('soapenv:Envelope');
    elem1.setAttribute('xmlns:soapenv', 'http://schemas.xmlsoap.org/soap/envelope/');
    let elem2 = doc.createElement('soapenv:Header');
    let elem3 = doc.createElement('wsse:Security');
    elem3.setAttribute('soapenv:mustUnderstand', '111');
    elem3.setAttribute(
      'xmlns:wsse',
      'http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd'
    );
    elem3.setAttribute(
      'xmlns:wsu',
      'http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd'
    );
    let elem4 = doc.createElement('wsse:UsernameToken');
    elem4.setAttribute('wsu:Id', 'UsernameToken-459');
    let elem5 = doc.createElement('wsse:Username');
    // this needs to be parameterized.
    elem5.innerHTML = this.encodeToXML(this.webMethodUserName);
    let elem6 = doc.createElement('wsse:Password');
    elem6.setAttribute(
      'Type',
      'http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText'
    );
    // this needs to be parameterized.
    elem6.innerHTML = this.encodeToXML(this.webMethodPass);
    elem4.appendChild(elem5);
    elem4.appendChild(elem6);
    elem3.appendChild(elem4);
    elem2.appendChild(elem3);
    let elem7 = doc.createElement('soapenv:Body');
    let elem8 = doc.createElement('ns4:createAndChange_Project');
    elem8.setAttribute('xmlns:ns2', 'urn:duk:objects:xmlschema:FIN:Project:version1.0.02Out');
    elem8.setAttribute('xmlns:ns3', 'urn:duk:objects:xmlschema:FIN:Project:version1.0.02');
    elem8.setAttribute('xmlns:ns4', 'urn:duk:objects:xmlschema:FIN:Project:version1.0.02In');
    elem8.setAttribute('xmlns:ns5', 'urn:duk:objects:xmlschema:INF:FaultReturn:version1.02');
    let elem9 = doc.createElement('MessageHeader');
    let elem10 = doc.createElement('identifier');
    elem10.innerHTML = this.encodeToXML('MMAPS_PPFC6EC80FCD9FCA1D.0');
    let elem11 = doc.createElement('referenceID');
    elem11.innerHTML = this.encodeToXML(
      'PLUSDESTVERSION_PLUSDESTVERSION :  Estimate Request=5581201 Estimate Version=4 Organization=DUKE'
    );
    let elem12 = doc.createElement('source');
    elem12.innerHTML = 'MMAPS';
    let elem13 = doc.createElement('target');
    elem13.innerHTML = 'POWERPLAN';
    elem9.appendChild(elem10);
    elem9.appendChild(elem11);
    elem9.appendChild(elem12);
    elem9.appendChild(elem13);
    let elem14 = doc.createElement('Project');
    let elem15 = doc.createElement('description');
    // Project Name
    elem15.innerHTML = this.encodeToXML(this.projectName);
    let elem16 = doc.createElement('type');
    // PowerPlan Project Type
    elem16.innerHTML = this.encodeToXML(this.powerPlanProjectType.description);
    let elem17 = doc.createElement('localID');
    // Charging Project ID
    elem17.innerHTML = this.chargingProjectID;
    let elem18 = doc.createElement('costEstimate');
    let elem19 = doc.createElement('currencyUnit');
    elem19.innerHTML = 'USD';
    let elem20 = doc.createElement('decimalValue');
    // Cost Estimate
    elem20.innerHTML = this.costEstimate.toString();
    elem18.appendChild(elem19);
    elem18.appendChild(elem20);
    let elem21 = doc.createElement('extendedDescription');
    // Project Long Description
    elem21.innerHTML = this.encodeToXML(this.projectLongDescription);
    let elem22 = doc.createElement('fundingProject');
    // Funding Project ID
    elem22.innerHTML = this.encodeToXML(this.fundingProjectID);
    let elem23 = doc.createElement('Dates');
    let elem24 = doc.createElement('date');
    let correctedDate = new Date();
    let dateOffset = 24 * 60 * 60 * 1000;
    // Estimated Start Date
    correctedDate.setTime(this.estimatedStartDate.getTime() - dateOffset);
    elem24.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem25 = doc.createElement('category');
    elem25.innerHTML = 'EstimatedStartDate';
    elem23.appendChild(elem24);
    elem23.appendChild(elem25);
    let elem26 = doc.createElement('Dates');
    let elem27 = doc.createElement('date');
    // Estimated Completion Date
    correctedDate.setTime(this.estimatedCompletionDate.getTime() - dateOffset);
    elem27.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem28 = doc.createElement('category');
    elem28.innerHTML = 'EstimatedCompletionDate';
    elem26.appendChild(elem27);
    elem26.appendChild(elem28);
    let elem29 = doc.createElement('Dates');
    let elem30 = doc.createElement('date');
    // Estimated In Service Date
    correctedDate.setTime(this.estimatedInServiceDate.getTime() - dateOffset);
    elem30.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem31 = doc.createElement('category');
    elem31.innerHTML = 'EstimatedInServiceDate';
    elem29.appendChild(elem30);
    elem29.appendChild(elem31);
    let elem32 = doc.createElement('Location');
    let elem33 = doc.createElement('localID');
    // Major Location (ID)
    elem33.innerHTML = this.encodeToXML(this.majorLocation.major_loc_id);
    elem32.appendChild(elem33);
    let activityElems = [];
    if (this.firstStandardActivity) {
      let actElem1 = doc.createElement('WorkTasks');
      let actElem2 = doc.createElement('localID');
      // Activity ID
      actElem2.innerHTML = this.firstStandardActivity;
      let actElem3 = doc.createElement('description');
      // Activity Description
      actElem3.innerHTML = this.firstStandardActivity;
      let actElem4 = doc.createElement('extendedDescription');
      // Activity Process (slot 1 of 2)
      actElem4.innerHTML = this.firstStandardActivity;
      let actElem5 = doc.createElement('ErpProjectAccounting');
      let actElem6 = doc.createElement('CodeBlock');
      let actElem7 = doc.createElement('businessUnit');
      let actElem8 = doc.createElement('process');
      // Activity Process (slot 2 of 2)
      actElem8.innerHTML = ' ';
      actElem6.appendChild(actElem7);
      actElem6.appendChild(actElem8);
      actElem5.appendChild(actElem6);
      actElem1.appendChild(actElem2);
      actElem1.appendChild(actElem3);
      actElem1.appendChild(actElem4);
      actElem1.appendChild(actElem5);
      activityElems.push(actElem1);
    }
    if (this.standardActivities) {
      for (let i = 0; i < this.standardActivities.length; i++) {
        let actElem1 = doc.createElement('WorkTasks');
        let actElem2 = doc.createElement('localID');
        // Activity ID
        actElem2.innerHTML = this.standardActivities[i];
        let actElem3 = doc.createElement('description');
        // Activity Description
        actElem3.innerHTML = this.standardActivities[i];
        let actElem4 = doc.createElement('extendedDescription');
        // Activity Process (slot 1 of 2)
        actElem4.innerHTML = this.standardActivities[i];
        let actElem5 = doc.createElement('ErpProjectAccounting');
        let actElem6 = doc.createElement('CodeBlock');
        let actElem7 = doc.createElement('businessUnit');
        let actElem8 = doc.createElement('process');
        // Activity Process (slot 2 of 2)
        actElem8.innerHTML = ' ';
        actElem6.appendChild(actElem7);
        actElem6.appendChild(actElem8);
        actElem5.appendChild(actElem6);
        actElem1.appendChild(actElem2);
        actElem1.appendChild(actElem3);
        actElem1.appendChild(actElem4);
        actElem1.appendChild(actElem5);
        activityElems.push(actElem1);
      }
    }
    if (this.firstActivity) {
      let actElem1 = doc.createElement('WorkTasks');
      let actElem2 = doc.createElement('localID');
      // Activity ID
      actElem2.innerHTML = this.encodeToXML(this.firstActivity.activityID);
      let actElem3 = doc.createElement('description');
      // Activity Description
      actElem3.innerHTML = this.encodeToXML(this.firstActivity.description);
      let actElem4 = doc.createElement('extendedDescription');
      // Activity Process (slot 1 of 2)
      actElem4.innerHTML = this.encodeToXML(this.firstActivity.process);
      let actElem5 = doc.createElement('ErpProjectAccounting');
      let actElem6 = doc.createElement('CodeBlock');
      let actElem7 = doc.createElement('businessUnit');
      let actElem8 = doc.createElement('process');
      // Activity Process (slot 2 of 2)
      actElem8.innerHTML = this.encodeToXML(this.firstActivity.process);
      actElem6.appendChild(actElem7);
      actElem6.appendChild(actElem8);
      actElem5.appendChild(actElem6);
      actElem1.appendChild(actElem2);
      actElem1.appendChild(actElem3);
      actElem1.appendChild(actElem4);
      actElem1.appendChild(actElem5);
      activityElems.push(actElem1);
    }
    if (this.activities) {
      for (let i = 0; i < this.activities.length; i++) {
        let actElem1 = doc.createElement('WorkTasks');
        let actElem2 = doc.createElement('localID');
        // Activity ID
        actElem2.innerHTML = this.encodeToXML(this.activities[i].activityID);
        let actElem3 = doc.createElement('description');
        // Activity Description
        actElem3.innerHTML = this.encodeToXML(this.activities[i].description);
        let actElem4 = doc.createElement('extendedDescription');
        // Activity Process (slot 1 of 2)
        actElem4.innerHTML = this.encodeToXML(this.activities[i].process);
        let actElem5 = doc.createElement('ErpProjectAccounting');
        let actElem6 = doc.createElement('CodeBlock');
        let actElem7 = doc.createElement('businessUnit');
        let actElem8 = doc.createElement('process');
        // Activity Process (slot 2 of 2)
        actElem8.innerHTML = this.encodeToXML(this.activities[i].process);
        actElem6.appendChild(actElem7);
        actElem6.appendChild(actElem8);
        actElem5.appendChild(actElem6);
        actElem1.appendChild(actElem2);
        actElem1.appendChild(actElem3);
        actElem1.appendChild(actElem4);
        actElem1.appendChild(actElem5);
        activityElems.push(actElem1);
      }
    }
    // Non-Graph API approach.
    let elem34 = doc.createElement('Persons');
    let elem35 = doc.createElement('Credentials');
    let elem36 = doc.createElement('userID');
    elem36.innerHTML = this.encodeToXML(this.projectManagerLAN);
    elem35.appendChild(elem36);
    let elem37 = doc.createElement('PersonRole');
    let elem38 = doc.createElement('name');
    elem38.innerHTML = 'ProjectManager';
    elem37.appendChild(elem38);
    elem34.appendChild(elem35);
    elem34.appendChild(elem37);
    let elem39 = doc.createElement('Persons');
    let elem40 = doc.createElement('Credentials');
    let elem41 = doc.createElement('userID');
    elem41.innerHTML = this.encodeToXML(this.contractAdminLAN);
    elem40.appendChild(elem41);
    let elem42 = doc.createElement('PersonRole');
    let elem43 = doc.createElement('name');
    elem43.innerHTML = 'ContractAdministrator';
    elem42.appendChild(elem43);
    elem39.appendChild(elem40);
    elem39.appendChild(elem42);
    let elem44 = doc.createElement('Persons');
    let elem45 = doc.createElement('Credentials');
    let elem45a = doc.createElement('userID');
    elem45a.innerHTML = this.encodeToXML(this.projectInitiatorLAN);
    //For Testing
    //elem45a.innerHTML = 'T18553';
    elem45.appendChild(elem45a);
    let elem45b = doc.createElement('PersonRole');
    let elem45c = doc.createElement('name');
    elem45c.innerHTML = 'ProjectInitiator';
    elem45b.appendChild(elem45c);
    elem44.appendChild(elem45);
    elem44.appendChild(elem45b);
    // Graph API Calls Removed
    /*let elem34 = doc.createElement("Persons");
    let elem35 = doc.createElement("localID");
    // Project Manager (Employee ID)
    elem35.innerHTML = this.projectManagerEID;
    let elem36 = doc.createElement("PersonRole");
    let elem37 = doc.createElement("name");
    elem37.innerHTML = "ProjectManager";
    elem36.appendChild(elem37);
    elem34.appendChild(elem35);
    elem34.appendChild(elem36);
    let elem38 = doc.createElement("Persons");
    let elem39 = doc.createElement("localID");
    // Contract Admin (Employee ID)
    elem39.innerHTML = this.contractAdminEID;
    let elem40 = doc.createElement("PersonRole");
    let elem41 = doc.createElement("name");
    elem41.innerHTML = "ContractAdministrator";
    elem40.appendChild(elem41);
    elem38.appendChild(elem39);
    elem38.appendChild(elem40);
    let elem42 = doc.createElement("Persons");
    let elem43 = doc.createElement("localID");
    // Project Initiator (Employee ID)
    elem43.innerHTML = this.projectInitiatorEID;
    let elem44 = doc.createElement("PersonRole");
    let elem45 = doc.createElement("name");
    elem45.innerHTML = "ProjectInitiator";
    elem44.appendChild(elem45);
    elem42.appendChild(elem43);
    elem42.appendChild(elem44);*/
    let elem46 = doc.createElement('remarks');
    // Problem Statement
    elem46.innerHTML = this.encodeToXML(this.problemStatement);
    let elem47 = doc.createElement('comment');
    // Notes
    elem47.innerHTML = this.encodeToXML(notesAugment);
    let elem48 = doc.createElement('reason');
    // Proposed Objective
    elem48.innerHTML = this.encodeToXML(this.proposedObjective);
    let elem49 = doc.createElement('Codes');
    let elem50 = doc.createElement('code');
    // Project Charge Indicator
    elem50.innerHTML = this.encodeToXML(this.projectChargeIndicator);
    let elem51 = doc.createElement('category');
    elem51.innerHTML = 'ProjectChargeCode';
    elem49.appendChild(elem50);
    elem49.appendChild(elem51);
    let elem52 = doc.createElement('Assets');
    let elem53 = doc.createElement('isReplacement');
    elem53.innerHTML = 'false';
    let elem54 = doc.createElement('Location');
    let elem55 = doc.createElement('localID');
    // Asset Location (ID)
    elem55.innerHTML = this.encodeToXML(this.assetLocation.ext_asset_location);
    elem54.appendChild(elem55);
    elem52.appendChild(elem53);
    elem52.appendChild(elem54);
    let elem56 = doc.createElement('ErpProjectAccounting');
    let elem57 = doc.createElement('CodeBlock');
    let elem58 = doc.createElement('businessUnit');
    // Business Unit
    elem58.innerHTML = this.encodeToXML(this.businessUnit.toString());
    let elem59 = doc.createElement('responsibilityCenter');
    // Resp Center
    elem59.innerHTML = this.encodeToXML(this.respCenter.DEPARTMENT_ID);
    let elem60 = doc.createElement('operatingUnit');
    // Operating Unit
    elem60.innerHTML = this.encodeToXML(this.operatingUnit.OPERATING_UNIT);
    let elem61 = doc.createElement('process');
    elem61.innerHTML = ' ';
    elem57.appendChild(elem58);
    elem57.appendChild(elem59);
    elem57.appendChild(elem60);
    elem57.appendChild(elem61);
    elem56.appendChild(elem57);
    let elem62 = doc.createElement('Transaction');
    let elem63 = doc.createElement('type');
    elem63.innerHTML = 'LOAD_PROJECT_HEADER';
    elem62.appendChild(elem63);
    elem14.appendChild(elem15);
    elem14.appendChild(elem16);
    elem14.appendChild(elem17);
    elem14.appendChild(elem18);
    elem14.appendChild(elem21);
    elem14.appendChild(elem22);
    elem14.appendChild(elem23);
    elem14.appendChild(elem26);
    elem14.appendChild(elem29);
    elem14.appendChild(elem32);
    for (let i = 0; i < activityElems.length; i++) {
      elem14.appendChild(activityElems[i]);
    }
    elem14.appendChild(elem34);
    elem14.appendChild(elem39);
    elem14.appendChild(elem44);
    // Graph API calls removed.
    /*elem14.appendChild(elem34);
    elem14.appendChild(elem38);
    elem14.appendChild(elem42);*/
    elem14.appendChild(elem46);
    elem14.appendChild(elem47);
    elem14.appendChild(elem48);
    elem14.appendChild(elem49);
    elem14.appendChild(elem52);
    elem14.appendChild(elem56);
    elem14.appendChild(elem62);
    elem8.appendChild(elem9);
    elem8.appendChild(elem14);
    elem7.appendChild(elem8);
    elem1.appendChild(elem2);
    elem1.appendChild(elem7);
    doc.appendChild(elem1);
    let finalString = '<?xml version="1.0" encoding="UTF-8"?>'.concat(
      doc.documentElement.outerHTML
    );
    this.dataService.submitProjectTEST(finalString).subscribe(
      (result) => {
        this.xmlDoc = this.parser.parseFromString(result, 'text/xml');
        if (
          this.xmlDoc.getElementsByTagName('Transaction')[0].childNodes[1].innerHTML === 'ERROR'
        ) {
          let dataStructure;
          let errors = this.xmlDoc.getElementsByTagName('errorMessage');
          let errorTexts = [];
          for (let i = 0; i < errors.length; i++) {
            errorTexts.push(errors[i].innerHTML);
          }
          dataStructure = {
            error: true,
            data: errorTexts,
          };
          this.dialog.open(SuccessDialogComponent, {
            disableClose: true,
            data: dataStructure,
          });
          this.submittingEstimate = false;
        } else {
          this.submitEstimate();
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Submit Project Error (Modifying Notes) - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Submit Project Error (Modifying Notes)');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
        this.submittingEstimate = false;
      }
    );
  }

  submitEstimate() {
    let doc = document.implementation.createDocument('', '', null);
    const pi = doc.createProcessingInstruction('xml', 'version="1.0" encoding="UTF-8"');
    doc.insertBefore(pi, doc.firstChild);
    let elem1 = doc.createElement('soapenv:Envelope');
    elem1.setAttribute('xmlns:soapenv', 'http://schemas.xmlsoap.org/soap/envelope/');
    let elem2 = doc.createElement('soapenv:Header');
    let elem3 = doc.createElement('wsse:Security');
    elem3.setAttribute('soapenv:mustUnderstand', '111');
    elem3.setAttribute(
      'xmlns:wsse',
      'http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd'
    );
    elem3.setAttribute(
      'xmlns:wsu',
      'http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd'
    );
    let elem4 = doc.createElement('wsse:UsernameToken');
    elem4.setAttribute('wsu:Id', 'UsernameToken-459');
    let elem5 = doc.createElement('wsse:Username');
    // this needs to be parameterized.
    elem5.innerHTML = this.encodeToXML(this.webMethodUserName);
    let elem6 = doc.createElement('wsse:Password');
    elem6.setAttribute(
      'Type',
      'http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText'
    );
    // this needs to be parameterized.
    elem6.innerHTML = this.encodeToXML(this.webMethodPass);
    elem4.appendChild(elem5);
    elem4.appendChild(elem6);
    elem3.appendChild(elem4);
    elem2.appendChild(elem3);
    let elem7 = doc.createElement('soapenv:Body');
    let elem8 = doc.createElement('ns4:createAndChange_Project');
    elem8.setAttribute('xmlns:ns2', 'urn:duk:objects:xmlschema:FIN:Project:version1.0.02Out');
    elem8.setAttribute('xmlns:ns3', 'urn:duk:objects:xmlschema:FIN:Project:version1.0.02');
    elem8.setAttribute('xmlns:ns4', 'urn:duk:objects:xmlschema:FIN:Project:version1.0.02In');
    elem8.setAttribute('xmlns:ns5', 'urn:duk:objects:xmlschema:INF:FaultReturn:version1.02');
    let elem9 = doc.createElement('MessageHeader');
    let elem10 = doc.createElement('identifier');
    elem10.innerHTML = this.encodeToXML('MMAPS_PPFC6EC80FCD9FCA1D.0');
    let elem11 = doc.createElement('referenceID');
    elem11.innerHTML = this.encodeToXML(
      'PLUSDESTVERSION_PLUSDESTVERSION :  Estimate Request=5581201 Estimate Version=4 Organization=DUKE'
    );
    let elem12 = doc.createElement('source');
    elem12.innerHTML = 'MMAPS';
    let elem13 = doc.createElement('target');
    elem13.innerHTML = 'POWERPLAN';
    elem9.appendChild(elem10);
    elem9.appendChild(elem11);
    elem9.appendChild(elem12);
    elem9.appendChild(elem13);
    let elem14 = doc.createElement('Project');
    let elem15 = doc.createElement('description');
    // Project Name
    elem15.innerHTML = this.encodeToXML(this.projectName);
    let elem16 = doc.createElement('type');
    // PowerPlan Project Type
    elem16.innerHTML = this.encodeToXML(this.powerPlanProjectType.description);
    let elem17 = doc.createElement('localID');
    // Charging Project ID
    elem17.innerHTML = this.chargingProjectID;
    let elem18 = doc.createElement('costEstimate');
    let elem19 = doc.createElement('currencyUnit');
    elem19.innerHTML = 'USD';
    let elem20 = doc.createElement('decimalValue');
    // Cost Estimate
    elem20.innerHTML = this.costEstimate.toString();
    elem18.appendChild(elem19);
    elem18.appendChild(elem20);
    let elem21 = doc.createElement('extendedDescription');
    // Project Long Description
    elem21.innerHTML = this.encodeToXML(this.projectLongDescription);
    let elem22 = doc.createElement('fundingProject');
    // Funding Project ID
    elem22.innerHTML = this.encodeToXML(this.fundingProjectID);
    let elem23 = doc.createElement('Dates');
    let elem24 = doc.createElement('date');
    let correctedDate = new Date();
    let dateOffset = 24 * 60 * 60 * 1000;
    // Estimated Start Date
    correctedDate.setTime(this.estimatedStartDate.getTime() - dateOffset);
    elem24.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem25 = doc.createElement('category');
    elem25.innerHTML = 'EstimatedStartDate';
    elem23.appendChild(elem24);
    elem23.appendChild(elem25);
    let elem26 = doc.createElement('Dates');
    let elem27 = doc.createElement('date');
    // Estimated Completion Date
    correctedDate.setTime(this.estimatedCompletionDate.getTime() - dateOffset);
    elem27.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem28 = doc.createElement('category');
    elem28.innerHTML = 'EstimatedCompletionDate';
    elem26.appendChild(elem27);
    elem26.appendChild(elem28);
    let elem29 = doc.createElement('Dates');
    let elem30 = doc.createElement('date');
    // Estimated In Service Date
    correctedDate.setTime(this.estimatedInServiceDate.getTime() - dateOffset);
    elem30.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem31 = doc.createElement('category');
    elem31.innerHTML = 'EstimatedInServiceDate';
    elem29.appendChild(elem30);
    elem29.appendChild(elem31);
    let elem32 = doc.createElement('Location');
    let elem33 = doc.createElement('localID');
    // Major Location (ID)
    elem33.innerHTML = this.encodeToXML(this.majorLocation.major_loc_id);
    elem32.appendChild(elem33);
    let activityElems = [];
    let estimateElems = [];
    if (this.firstStandardActivity) {
      let actElem1 = doc.createElement('WorkTasks');
      let actElem2 = doc.createElement('localID');
      // Activity ID
      actElem2.innerHTML = this.firstStandardActivity;
      let actElem3 = doc.createElement('description');
      // Activity Description
      actElem3.innerHTML = this.firstStandardActivity;
      let actElem4 = doc.createElement('extendedDescription');
      // Activity Process (slot 1 of 2)
      actElem4.innerHTML = this.firstStandardActivity;
      let actElem5 = doc.createElement('ErpProjectAccounting');
      let actElem6 = doc.createElement('CodeBlock');
      let actElem7 = doc.createElement('businessUnit');
      let actElem8 = doc.createElement('process');
      // Activity Process (slot 2 of 2)
      actElem8.innerHTML = ' ';
      actElem6.appendChild(actElem7);
      actElem6.appendChild(actElem8);
      actElem5.appendChild(actElem6);
      actElem1.appendChild(actElem2);
      actElem1.appendChild(actElem3);
      actElem1.appendChild(actElem4);
      actElem1.appendChild(actElem5);
      activityElems.push(actElem1);
    }
    if (this.standardActivities) {
      for (let i = 0; i < this.standardActivities.length; i++) {
        let actElem1 = doc.createElement('WorkTasks');
        let actElem2 = doc.createElement('localID');
        // Activity ID
        actElem2.innerHTML = this.standardActivities[i];
        let actElem3 = doc.createElement('description');
        // Activity Description
        actElem3.innerHTML = this.standardActivities[i];
        let actElem4 = doc.createElement('extendedDescription');
        // Activity Process (slot 1 of 2)
        actElem4.innerHTML = this.standardActivities[i];
        let actElem5 = doc.createElement('ErpProjectAccounting');
        let actElem6 = doc.createElement('CodeBlock');
        let actElem7 = doc.createElement('businessUnit');
        let actElem8 = doc.createElement('process');
        // Activity Process (slot 2 of 2)
        actElem8.innerHTML = ' ';
        actElem6.appendChild(actElem7);
        actElem6.appendChild(actElem8);
        actElem5.appendChild(actElem6);
        actElem1.appendChild(actElem2);
        actElem1.appendChild(actElem3);
        actElem1.appendChild(actElem4);
        actElem1.appendChild(actElem5);
        activityElems.push(actElem1);
      }
    }
    if (this.firstActivity) {
      let actElem1 = doc.createElement('WorkTasks');
      let actElem2 = doc.createElement('localID');
      // Activity ID
      actElem2.innerHTML = this.encodeToXML(this.firstActivity.activityID);
      let actElem3 = doc.createElement('description');
      // Activity Description
      actElem3.innerHTML = this.encodeToXML(this.firstActivity.description);
      let actElem4 = doc.createElement('extendedDescription');
      // Activity Process (slot 1 of 2)
      actElem4.innerHTML = this.encodeToXML(this.firstActivity.process);
      let actElem5 = doc.createElement('ErpProjectAccounting');
      let actElem6 = doc.createElement('CodeBlock');
      let actElem7 = doc.createElement('businessUnit');
      let actElem8 = doc.createElement('process');
      // Activity Process (slot 2 of 2)
      actElem8.innerHTML = this.encodeToXML(this.firstActivity.process);
      actElem6.appendChild(actElem7);
      actElem6.appendChild(actElem8);
      actElem5.appendChild(actElem6);
      actElem1.appendChild(actElem2);
      actElem1.appendChild(actElem3);
      actElem1.appendChild(actElem4);
      actElem1.appendChild(actElem5);
      activityElems.push(actElem1);
    }
    if (this.activities) {
      for (let i = 0; i < this.activities.length; i++) {
        let actElem1 = doc.createElement('WorkTasks');
        let actElem2 = doc.createElement('localID');
        // Activity ID
        actElem2.innerHTML = this.encodeToXML(this.activities[i].activityID);
        let actElem3 = doc.createElement('description');
        // Activity Description
        actElem3.innerHTML = this.encodeToXML(this.activities[i].description);
        let actElem4 = doc.createElement('extendedDescription');
        // Activity Process (slot 1 of 2)
        actElem4.innerHTML = this.encodeToXML(this.activities[i].process);
        let actElem5 = doc.createElement('ErpProjectAccounting');
        let actElem6 = doc.createElement('CodeBlock');
        let actElem7 = doc.createElement('businessUnit');
        let actElem8 = doc.createElement('process');
        // Activity Process (slot 2 of 2)
        actElem8.innerHTML = this.encodeToXML(this.activities[i].process);
        actElem6.appendChild(actElem7);
        actElem6.appendChild(actElem8);
        actElem5.appendChild(actElem6);
        actElem1.appendChild(actElem2);
        actElem1.appendChild(actElem3);
        actElem1.appendChild(actElem4);
        actElem1.appendChild(actElem5);
        activityElems.push(actElem1);
      }
    }
    // Non-Graph API approach.
    let elem34 = doc.createElement('Persons');
    let elem35 = doc.createElement('Credentials');
    let elem36 = doc.createElement('userID');
    elem36.innerHTML = this.encodeToXML(this.projectManagerLAN);
    elem35.appendChild(elem36);
    let elem37 = doc.createElement('PersonRole');
    let elem38 = doc.createElement('name');
    elem38.innerHTML = 'ProjectManager';
    elem37.appendChild(elem38);
    elem34.appendChild(elem35);
    elem34.appendChild(elem37);
    let elem39 = doc.createElement('Persons');
    let elem40 = doc.createElement('Credentials');
    let elem41 = doc.createElement('userID');
    elem41.innerHTML = this.encodeToXML(this.contractAdminLAN);
    elem40.appendChild(elem41);
    let elem42 = doc.createElement('PersonRole');
    let elem43 = doc.createElement('name');
    elem43.innerHTML = 'ContractAdministrator';
    elem42.appendChild(elem43);
    elem39.appendChild(elem40);
    elem39.appendChild(elem42);
    let elem44 = doc.createElement('Persons');
    let elem45 = doc.createElement('Credentials');
    let elem45a = doc.createElement('userID');
    elem45a.innerHTML = this.encodeToXML(this.projectInitiatorLAN);
    //For Testing
    //elem45a.innerHTML = 'T18553';
    elem45.appendChild(elem45a);
    let elem45b = doc.createElement('PersonRole');
    let elem45c = doc.createElement('name');
    elem45c.innerHTML = 'ProjectInitiator';
    elem45b.appendChild(elem45c);
    elem44.appendChild(elem45);
    elem44.appendChild(elem45b);
    // Graph API Calls Removed
    /*let elem34 = doc.createElement("Persons");
    let elem35 = doc.createElement("localID");
    // Project Manager (Employee ID)
    elem35.innerHTML = this.projectManagerEID;
    let elem36 = doc.createElement("PersonRole");
    let elem37 = doc.createElement("name");
    elem37.innerHTML = "ProjectManager";
    elem36.appendChild(elem37);
    elem34.appendChild(elem35);
    elem34.appendChild(elem36);
    let elem38 = doc.createElement("Persons");
    let elem39 = doc.createElement("localID");
    // Contract Admin (Employee ID)
    elem39.innerHTML = this.contractAdminEID;
    let elem40 = doc.createElement("PersonRole");
    let elem41 = doc.createElement("name");
    elem41.innerHTML = "ContractAdministrator";
    elem40.appendChild(elem41);
    elem38.appendChild(elem39);
    elem38.appendChild(elem40);
    let elem42 = doc.createElement("Persons");
    let elem43 = doc.createElement("localID");
    // Project Initiator (Employee ID)
    elem43.innerHTML = this.projectInitiatorEID;
    let elem44 = doc.createElement("PersonRole");
    let elem45 = doc.createElement("name");
    elem45.innerHTML = "ProjectInitiator";
    elem44.appendChild(elem45);
    elem42.appendChild(elem43);
    elem42.appendChild(elem44);*/
    let elem46 = doc.createElement('remarks');
    // Problem Statement
    elem46.innerHTML = this.encodeToXML(this.problemStatement);
    let elem47 = doc.createElement('comment');
    // Notes
    elem47.innerHTML = this.encodeToXML(this.notes);
    let elem48 = doc.createElement('reason');
    // Proposed Objective
    elem48.innerHTML = this.encodeToXML(this.proposedObjective);
    let elem49 = doc.createElement('Codes');
    let elem50 = doc.createElement('code');
    // Project Charge Indicator
    elem50.innerHTML = this.encodeToXML(this.projectChargeIndicator);
    let elem51 = doc.createElement('category');
    elem51.innerHTML = 'ProjectChargeCode';
    elem49.appendChild(elem50);
    elem49.appendChild(elem51);
    let elem52 = doc.createElement('Assets');
    let elem53 = doc.createElement('isReplacement');
    elem53.innerHTML = 'false';
    let elem54 = doc.createElement('Location');
    let elem55 = doc.createElement('localID');
    // Asset Location (ID)
    elem55.innerHTML = this.encodeToXML(this.assetLocation.ext_asset_location);
    elem54.appendChild(elem55);
    elem52.appendChild(elem53);
    elem52.appendChild(elem54);
    let elem56 = doc.createElement('ErpProjectAccounting');
    let elem57 = doc.createElement('CodeBlock');
    let elem58 = doc.createElement('businessUnit');
    // Business Unit
    elem58.innerHTML = this.encodeToXML(this.businessUnit.toString());
    let elem59 = doc.createElement('responsibilityCenter');
    // Resp Center
    elem59.innerHTML = this.encodeToXML(this.respCenter.DEPARTMENT_ID);
    let elem60 = doc.createElement('operatingUnit');
    // Operating Unit
    elem60.innerHTML = this.encodeToXML(this.operatingUnit.OPERATING_UNIT);
    let elem61 = doc.createElement('process');
    elem61.innerHTML = ' ';
    elem57.appendChild(elem58);
    elem57.appendChild(elem59);
    elem57.appendChild(elem60);
    elem57.appendChild(elem61);
    elem56.appendChild(elem57);
    let elem62 = doc.createElement('Transaction');
    let elem63 = doc.createElement('type');
    elem63.innerHTML = 'LOAD_ESTIMATES';
    elem62.appendChild(elem63);
    let estimateEntries = [];
    if (this.projectEstimates) {
      for (let i = 0; i < this.projectEstimates.length; i++) {
        let estimateElem1 = doc.createElement('Estimates');
        let estimateElem2 = doc.createElement('quantity');
        if (this.projectEstimates[i].quantity) {
          estimateElem2.innerHTML = this.projectEstimates[i].quantity.toString();
        } else {
          estimateElem2.innerHTML = '0';
        }
        let estimateElem3 = doc.createElement('category');
        estimateElem3.innerHTML = 'DESIGN';
        let estimateElem4;
        estimateElem4 = doc.createElement('MeasurementType');
        let estimateElem5 = doc.createElement('name');
        if (this.projectEstimates[i].unitReminder.uom_reminder === 'Measured by Each') {
          estimateElem5.innerHTML = 'EA';
        } else if (this.projectEstimates[i].unitReminder.uom_reminder === 'Measured by Feet') {
          estimateElem5.innerHTML = 'FT';
        }
        estimateElem4.appendChild(estimateElem5);
        let estimateElem6 = doc.createElement('Work');
        let estimateElem6a = doc.createElement('localID');
        estimateElem6a.innerHTML = this.chargingProjectID;
        let estimateElem7 = doc.createElement('WorkCostDetail');
        let estimateElem8 = doc.createElement('amount');
        let estimateElem9 = doc.createElement('currencyUnit');
        estimateElem9.innerHTML = 'USD';
        let estimateElem10 = doc.createElement('multiplier');
        estimateElem10.innerHTML = 'none';
        let estimateElem11 = doc.createElement('decimalValue');
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Material')) {
          estimateElem11.innerHTML = this.projectEstimates[i].estimatedCosts.toString();
        } else {
          estimateElem11.innerHTML = '0.00';
        }
        estimateElem8.appendChild(estimateElem9);
        estimateElem8.appendChild(estimateElem10);
        estimateElem8.appendChild(estimateElem11);
        let estimateElem12 = doc.createElement('typeWorkCost');
        estimateElem12.innerHTML = 'InternalMaterialsAmount';
        estimateElem7.appendChild(estimateElem8);
        estimateElem7.appendChild(estimateElem12);
        let estimateElem13 = doc.createElement('WorkCostDetail');
        let estimateElem14 = doc.createElement('amount');
        let estimateElem15 = doc.createElement('currencyUnit');
        estimateElem15.innerHTML = 'USD';
        let estimateElem16 = doc.createElement('multiplier');
        estimateElem16.innerHTML = 'none';
        let estimateElem17 = doc.createElement('decimalValue');
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Labor')) {
          estimateElem17.innerHTML = this.projectEstimates[i].estimatedCosts.toString();
        } else {
          estimateElem17.innerHTML = '0.00';
        }
        estimateElem14.appendChild(estimateElem15);
        estimateElem14.appendChild(estimateElem16);
        estimateElem14.appendChild(estimateElem17);
        let estimateElem18 = doc.createElement('typeWorkCost');
        estimateElem18.innerHTML = 'InternalLaborAmount';
        estimateElem13.appendChild(estimateElem14);
        estimateElem13.appendChild(estimateElem18);
        let estimateElem19 = doc.createElement('WorkCostDetail');
        let estimateElem20 = doc.createElement('amount');
        let estimateElem21 = doc.createElement('currencyUnit');
        estimateElem21.innerHTML = 'USD';
        let estimateElem22 = doc.createElement('multiplier');
        estimateElem22.innerHTML = 'none';
        let estimateElem23 = doc.createElement('decimalValue');
        estimateElem23.innerHTML = '0.00';
        estimateElem20.appendChild(estimateElem21);
        estimateElem20.appendChild(estimateElem22);
        estimateElem20.appendChild(estimateElem23);
        let estimateElem24 = doc.createElement('typeWorkCost');
        estimateElem24.innerHTML = 'InternalToolsAmount';
        estimateElem19.appendChild(estimateElem20);
        estimateElem19.appendChild(estimateElem24);
        let estimateElem25 = doc.createElement('WorkCostDetail');
        let estimateElem26 = doc.createElement('amount');
        let estimateElem27 = doc.createElement('currencyUnit');
        estimateElem27.innerHTML = 'USD';
        let estimateElem28 = doc.createElement('multiplier');
        estimateElem28.innerHTML = 'none';
        let estimateElem29 = doc.createElement('decimalValue');
        estimateElem29.innerHTML = '0.00';
        estimateElem26.appendChild(estimateElem27);
        estimateElem26.appendChild(estimateElem28);
        estimateElem26.appendChild(estimateElem29);
        let estimateElem30 = doc.createElement('typeWorkCost');
        estimateElem30.innerHTML = 'ExternalToolsAmount';
        estimateElem25.appendChild(estimateElem26);
        estimateElem25.appendChild(estimateElem30);
        let estimateElem31 = doc.createElement('WorkCostDetail');
        let estimateElem32 = doc.createElement('amount');
        let estimateElem33 = doc.createElement('currencyUnit');
        estimateElem33.innerHTML = 'USD';
        let estimateElem34 = doc.createElement('multiplier');
        estimateElem34.innerHTML = 'none';
        let estimateElem35 = doc.createElement('decimalValue');
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Other')) {
          estimateElem35.innerHTML = this.projectEstimates[i].estimatedCosts.toString();
        } else {
          estimateElem35.innerHTML = '0.00';
        }
        estimateElem32.appendChild(estimateElem33);
        estimateElem32.appendChild(estimateElem34);
        estimateElem32.appendChild(estimateElem35);
        let estimateElem36 = doc.createElement('typeWorkCost');
        estimateElem36.innerHTML = 'ServiceAmount';
        estimateElem31.appendChild(estimateElem32);
        estimateElem31.appendChild(estimateElem36);
        let estimateElem37 = doc.createElement('WorkCostDetail');
        let estimateElem38 = doc.createElement('amount');
        let estimateElem39 = doc.createElement('currencyUnit');
        estimateElem39.innerHTML = 'USD';
        let estimateElem40 = doc.createElement('multiplier');
        estimateElem40.innerHTML = 'none';
        let estimateElem41 = doc.createElement('decimalValue');
        estimateElem41.innerHTML = '0.00';
        estimateElem38.appendChild(estimateElem39);
        estimateElem38.appendChild(estimateElem40);
        estimateElem38.appendChild(estimateElem41);
        let estimateElem42 = doc.createElement('typeWorkCost');
        estimateElem42.innerHTML = 'SalvageAmount';
        estimateElem37.appendChild(estimateElem38);
        estimateElem37.appendChild(estimateElem42);
        let estimateElem43 = doc.createElement('WorkCostDetail');
        let estimateElem44 = doc.createElement('amount');
        let estimateElem45 = doc.createElement('currencyUnit');
        estimateElem45.innerHTML = 'USD';
        let estimateElem46 = doc.createElement('multiplier');
        estimateElem46.innerHTML = 'none';
        let estimateElem47 = doc.createElement('decimalValue');
        estimateElem47.innerHTML = '0.00';
        estimateElem44.appendChild(estimateElem45);
        estimateElem44.appendChild(estimateElem46);
        estimateElem44.appendChild(estimateElem47);
        let estimateElem48 = doc.createElement('typeWorkCost');
        estimateElem48.innerHTML = 'LoadingAmount';
        estimateElem43.appendChild(estimateElem44);
        estimateElem43.appendChild(estimateElem48);
        let estimateElem49 = doc.createElement('WorkCostDetail');
        let estimateElem50 = doc.createElement('amount');
        let estimateElem51 = doc.createElement('currencyUnit');
        estimateElem51.innerHTML = 'USD';
        let estimateElem52 = doc.createElement('multiplier');
        estimateElem52.innerHTML = 'none';
        let estimateElem53 = doc.createElement('decimalValue');
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Other')) {
          estimateElem53.innerHTML = this.projectEstimates[i].estimatedCosts.toString();
        } else {
          estimateElem53.innerHTML = '0.00';
        }
        estimateElem50.appendChild(estimateElem51);
        estimateElem50.appendChild(estimateElem52);
        estimateElem50.appendChild(estimateElem53);
        let estimateElem54 = doc.createElement('typeWorkCost');
        estimateElem54.innerHTML = 'AppliedContributionAmount';
        estimateElem49.appendChild(estimateElem50);
        estimateElem49.appendChild(estimateElem54);
        let estimateElem55 = doc.createElement('WorkCostDetail');
        let estimateElem56 = doc.createElement('amount');
        let estimateElem57 = doc.createElement('currencyUnit');
        estimateElem57.innerHTML = 'USD';
        let estimateElem58 = doc.createElement('multiplier');
        estimateElem58.innerHTML = 'none';
        let estimateElem59 = doc.createElement('decimalValue');
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Contractor')) {
          estimateElem59.innerHTML = this.projectEstimates[i].estimatedCosts.toString();
        } else {
          estimateElem59.innerHTML = '0.00';
        }
        estimateElem56.appendChild(estimateElem57);
        estimateElem56.appendChild(estimateElem58);
        estimateElem56.appendChild(estimateElem59);
        let estimateElem60 = doc.createElement('typeWorkCost');
        estimateElem60.innerHTML = 'ExternalLaborAmount';
        estimateElem55.appendChild(estimateElem56);
        estimateElem55.appendChild(estimateElem60);
        let estimateElem61 = doc.createElement('WorkCostDetail');
        let estimateElem62 = doc.createElement('amount');
        let estimateElem63 = doc.createElement('currencyUnit');
        estimateElem63.innerHTML = 'USD';
        let estimateElem64 = doc.createElement('multiplier');
        estimateElem64.innerHTML = 'none';
        let estimateElem65 = doc.createElement('decimalValue');
        estimateElem65.innerHTML = '0.00';
        estimateElem62.appendChild(estimateElem63);
        estimateElem62.appendChild(estimateElem64);
        estimateElem62.appendChild(estimateElem65);
        let estimateElem66 = doc.createElement('typeWorkCost');
        estimateElem66.innerHTML = 'ExternalMaterialsAmount';
        estimateElem61.appendChild(estimateElem62);
        estimateElem61.appendChild(estimateElem66);
        estimateElem6.appendChild(estimateElem6a);
        estimateElem6.appendChild(estimateElem7);
        estimateElem6.appendChild(estimateElem13);
        estimateElem6.appendChild(estimateElem19);
        estimateElem6.appendChild(estimateElem25);
        estimateElem6.appendChild(estimateElem31);
        estimateElem6.appendChild(estimateElem37);
        estimateElem6.appendChild(estimateElem43);
        estimateElem6.appendChild(estimateElem49);
        estimateElem6.appendChild(estimateElem55);
        estimateElem6.appendChild(estimateElem61);
        let estimateElem67 = doc.createElement('Asset');
        let estimateElem68 = doc.createElement('Location');
        let estimateElem69 = doc.createElement('localID');
        estimateElem69.innerHTML = this.encodeToXML(
          this.projectEstimates[i].assetLocation.ext_asset_location
        );
        estimateElem68.appendChild(estimateElem69);
        estimateElem67.appendChild(estimateElem68);
        let estimateElem70 = doc.createElement('Transaction');
        let estimateElem71 = doc.createElement('type');
        estimateElem71.innerHTML = 'UOP';
        let estimateElem72 = doc.createElement('sourceSystem');
        estimateElem72.innerHTML = 'MMAPS';
        let estimateElem73 = doc.createElement('ErpProjectAccounting');
        let estimateElem74 = doc.createElement('retirementUnit');
        estimateElem74.innerHTML = this.encodeToXML(
          this.projectEstimates[i].retirementUnit.retirement_unit_id
        );
        let estimateElem75 = doc.createElement('utilityAccount');
        estimateElem75.innerHTML = this.projectEstimates[i].utilityAccount.utility_account_id;
        estimateElem73.appendChild(estimateElem74);
        estimateElem73.appendChild(estimateElem75);
        let estimateElem76 = doc.createElement('PropertyUnit');
        let estimateElem77 = doc.createElement('workActionKind');
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Install')) {
          estimateElem77.innerHTML = 'Addition';
        }
        if (this.projectEstimates[i].chargeType.chg_type_descr.includes('Removal')) {
          estimateElem77.innerHTML = 'Retirement';
        }
        estimateElem76.appendChild(estimateElem77);
        let estimateElem78 = doc.createElement('Person');
        let estimateElem79 = doc.createElement('localID');
        estimateElem79.innerHTML = this.encodeToXML(this.projectInitiatorLAN);
        let estimateElem80 = doc.createElement('PersonRole');
        let estimateElem81 = doc.createElement('name');
        estimateElem81.innerHTML = 'Sender';
        estimateElem80.appendChild(estimateElem81);
        estimateElem78.appendChild(estimateElem79);
        estimateElem78.appendChild(estimateElem80);
        estimateElem70.appendChild(estimateElem71);
        estimateElem70.appendChild(estimateElem72);
        estimateElem70.appendChild(estimateElem73);
        estimateElem70.appendChild(estimateElem76);
        estimateElem70.appendChild(estimateElem78);
        estimateElem1.appendChild(estimateElem2);
        estimateElem1.appendChild(estimateElem3);
        estimateElem1.appendChild(estimateElem4);
        estimateElem1.appendChild(estimateElem6);
        estimateElem1.appendChild(estimateElem67);
        estimateElem1.appendChild(estimateElem70);
        estimateEntries.push(estimateElem1);
      }
    }
    elem14.appendChild(elem15);
    elem14.appendChild(elem16);
    elem14.appendChild(elem17);
    elem14.appendChild(elem18);
    elem14.appendChild(elem21);
    elem14.appendChild(elem22);
    elem14.appendChild(elem23);
    elem14.appendChild(elem26);
    elem14.appendChild(elem29);
    elem14.appendChild(elem32);
    for (let i = 0; i < activityElems.length; i++) {
      elem14.appendChild(activityElems[i]);
    }
    elem14.appendChild(elem34);
    elem14.appendChild(elem39);
    elem14.appendChild(elem44);
    // Graph API calls removed.
    /*elem14.appendChild(elem34);
    elem14.appendChild(elem38);
    elem14.appendChild(elem42);*/
    elem14.appendChild(elem46);
    elem14.appendChild(elem47);
    elem14.appendChild(elem48);
    elem14.appendChild(elem49);
    elem14.appendChild(elem52);
    elem14.appendChild(elem56);
    elem14.appendChild(elem62);
    for (let i = 0; i < estimateEntries.length; i++) {
      elem14.appendChild(estimateEntries[i]);
    }
    elem8.appendChild(elem9);
    elem8.appendChild(elem14);
    elem7.appendChild(elem8);
    elem1.appendChild(elem2);
    elem1.appendChild(elem7);
    doc.appendChild(elem1);
    //console.log(doc);
    let finalString = '<?xml version="1.0" encoding="UTF-8"?>'.concat(
      doc.documentElement.outerHTML
    );
    this.dataService.submitProjectTEST(finalString).subscribe(
      (result) => {
        this.xmlDoc = this.parser.parseFromString(result, 'text/xml');
        if (
          this.xmlDoc.getElementsByTagName('Transaction')[0].childNodes[1].innerHTML === 'ERROR'
        ) {
          let dataStructure;
          let errors = this.xmlDoc.getElementsByTagName('errorMessage');
          let errorTexts = [];
          for (let i = 0; i < errors.length; i++) {
            errorTexts.push(errors[i].innerHTML);
          }
          dataStructure = {
            error: true,
            data: errorTexts,
            isEstimate: true,
          };
          this.dialog.open(SuccessDialogComponent, {
            disableClose: true,
            data: dataStructure,
          });
          this.submittingEstimate = false;
        } else {
          let dataStructure = {
            error: false,
            data: this.chargingProjectID,
            isEstimate: true,
          };
          this.dialog.open(SuccessDialogComponent, {
            disableClose: true,
            data: dataStructure,
          });
        }
        this.submittingEstimate = false;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Submit Project Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Submit Project Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
          isEstimate: true,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
        this.submittingEstimate = false;
      }
    );
  }

  encodeToXML(encodeString: string) {
    if (encodeString) {
      return encodeString
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
    } else {
      return '';
    }
  }

  exitPage() {
    this.router.navigate(['/dashboard']);
  }

  submissionDisabled() {
    if (this.projectEstimates.length === 0 && this.capitalRetirements.length === 0) {
      return true;
    }
    let estimatesFilledOut = true;
    let retirementsFilledOut = true;
    if (this.projectEstimates.length > 0) {
      let estimatesScanFinished = false;
      for (var i = 0; i < this.projectEstimates.length && !estimatesScanFinished; i++) {
        if (
          !this.projectEstimates[i].projectFunction ||
          !this.projectEstimates[i].utilityAccount ||
          !this.projectEstimates[i].retirementUnit ||
          !this.projectEstimates[i].chargeType ||
          !this.projectEstimates[i].assetLocation ||
          !this.projectEstimates[i].estimatedCosts
        ) {
          estimatesFilledOut = false;
          estimatesScanFinished = true;
        } else if (
          this.projectEstimates[i].chargeType.chg_type_descr.substring(0, 8) === 'Material' &&
          !this.projectEstimates[i].quantity
        ) {
          estimatesFilledOut = false;
          estimatesScanFinished = true;
        }
      }
    }
    if (this.capitalRetirements.length > 0) {
      let retirementsScanFinished = false;
      for (var i = 0; i < this.capitalRetirements.length && !retirementsScanFinished; i++) {
        if (
          !this.capitalRetirements[i].utilityAccountBeingRemoved ||
          !this.capitalRetirements[i].retirementUnit ||
          !this.capitalRetirements[i].originalInstalledYear ||
          !this.capitalRetirements[i].quantity
        ) {
          retirementsFilledOut = false;
          retirementsScanFinished = true;
        }
      }
    }
    return !(estimatesFilledOut && retirementsFilledOut);
  }
}
